import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostResultDenomination = (params, setOpenModal) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_BETS_FREESPIN
            });

            if (data.status === 'success') {
                setOpenModal(data.data);
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostResultDenomination as SetPostResultDenomination
}